import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.scss'],
})
export class PrivacyPolicyComponent {
  readonly pdfUrl = 'assets/pdf/DPO.pdf';

  @Output() closeDPO = new EventEmitter();
  @Input() showDPO = false;

  closeModal() {
    this.closeDPO.emit();
  }
}
